import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { VueAutosuggest } from "vue-autosuggest";
import LoadingIcon from "@/assets/images/icons/loading-white.svg?inline";

import RegistrationOptions from "@/views/auth/QuestionaryAuth/RegistrationOptions";
import SignUpForm from "@/views/auth/components/SignUpForm";
import ConfirmPhoneSlide from "@/views/auth/ConfirmationPhone";
import ConfirmEmailSlide from "@/views/auth/ConfirmationEmail";

import debounce from "lodash/debounce";

import { mapGetters } from "vuex";

import {
  CLAIMED_PROPERTIES_AUTOCOMPLETE,
  CREATE_CLAIMED_PROPERTY,
  GET_USER
} from "../../gql/SellerQueries";

export default {
  name: "claim_home",

  data() {
    return {
      quizSwiper: null,
      swiperOption: {
        height: 667,
        speed: 800,
        simulateTouch: false,
        allowTouchMove: false
      },

      question: {
        text: "What is your home address?",
        placeholder: "123 Main Street, Chicago, IL 60555"
      },

      propertyParams: {
        address: "",
        listPrice: "1",
        receiveOffers: {
          values: [
            {type: 'multi_select', value: 'now', actual: '', text: 'Now'},
            {type: 'multi_select', value: 'next_month', actual: '', text: 'Next Month'},
            {type: 'multi_select', value: 'next_year', actual: '', text: 'Next Year'},
          ],
          actual: ''
        }
      },

      submitLoading: false,
      skipPlacesQuery: true,

      placesRequestQuery: "",
      placesQuery: "",
      claimedPropertiesAutocomplete: [],
      showAnswerTooltip: false,

      createdProperty: null,
      skipGetUserQuery: true,

      isManualRegistration: false,
      isEmailRegistration: false
    };
  },

  props: [],

  apollo: {
    claimedPropertiesAutocomplete: {
      query: CLAIMED_PROPERTIES_AUTOCOMPLETE,
      variables() {
        return {
          input: this.placesRequestQuery
        };
      },
      skip() {
        return this.skipPlacesQuery;
      },
      result() {
        this.skipPlacesQuery = true;
      }
    },

    getUser: {
      query: GET_USER,
      fetchPolicy: "no-cache",
      skip() {
        return this.skipGetUserQuery;
      },
      result({ data: { getUser } }) {
        this.$store.commit("setUserInfo", getUser);
        this.skipGetUserQuery = true;

        this.$router.push({
          name: "property",
          params: { id: this.createdProperty.id }
        });
      }
    }
  },

  mounted() {
    this.quizSwiper = this.$refs.mySwiper.swiper;
  },

  computed: {
    filteredOptions() {
      const filtered = [];

      if (!this.placesQuery) {
        return [];
      }

      this.claimedPropertiesAutocomplete.forEach(r => {
        filtered.push({
          label: r.type,
          data: r.places,
          limit: 5,
          onSelected: selected => {
            this.selected = selected.item;
          }
        });
      });

      return Object.freeze(filtered);
    },

    ...mapGetters({
      currentUser: "getUser"
    })
  },

  methods: {
    nextQuestion(item) {
      if (item) {
        this.propertyParams.address = item.item.description;
      }
      if (!this.propertyParams.address) return;

      this.quizSwiper.slideNext();
    },

    createHouse() {
      this.$apollo
        .mutate({
          mutation: CREATE_CLAIMED_PROPERTY,
          variables: {
            address: this.propertyParams.address,
            listPrice: parseInt(this.propertyParams.listPrice),
            unitNumber: this.propertyParams.unitNumber,
            contactFrequency: this.propertyParams.receiveOffers.actual
          }
        })
        .then(({ data: { createClaimedProperty: { property } } }) => {
          this.submitLoading = false;

          this.createdProperty = property;

          this.updateUserCanClaimProperty();
        })
        .catch(mutationError => {
          const errors = mutationError.graphQLErrors;

          for (let error in errors) {
            this.$toasted.error(errors[error].message);
          }

          this.submitLoading = false;
        });
    },

    updateUserCanClaimProperty() {
      this.skipGetUserQuery = false;
    },

    resetQuestion() {
      this.placesQuery = "";
      this.propertyParams.address = "";
      this.propertyParams.listPrice = "";
      this.propertyParams.unitNumber = "";
      this.quizSwiper.slideTo(0);
    },

    getSuggestionValue(suggestion) {
      return suggestion.item.description;
    },

    nextTickSlide(type = "") {
      this.isEmailRegistration = type == "email" ? true : false;

      this.$nextTick(() => {
        this.quizSwiper.slideNext();
      });
    },

    handleManualRegistration() {
      this.isManualRegistration = true;

      this.nextTickSlide();
    },
  },

  watch: {
    placesQuery: debounce(function(newQuestion) {
      if (newQuestion.length >= 2) {
        this.placesRequestQuery = newQuestion;

        this.skipPlacesQuery = false;
      }
    }, 300)
  },

  components: {
    swiper,
    swiperSlide,
    VueAutosuggest,
    LoadingIcon,
    RegistrationOptions,
    SignUpForm,
    ConfirmPhoneSlide,
    ConfirmEmailSlide,
  }
};
